//预加载图片资源,活动弹窗
export default [
    require("@/assets/img/act-notice/HD_tc_bg.png"),
    require("@/assets/img/act-notice/HD_bt_zi.png"),
    require("@/assets/img/act-notice/HD_title_zyq_1.png"),
    require("@/assets/img/act-notice/HD_title_zyq_2.png"),
    require("@/assets/img/act-notice/HD_title_yyq_1.png"),
    require("@/assets/img/act-notice/HD_title_yyq_2.png"),
    require("@/assets/img/act-notice/HD_gg_yq_2.png"),
    require("@/assets/img/act-notice/HD_hd_logo_2.png"),
    require("@/assets/img/act-notice/HD_gg_logo_2.png"),
    require("@/assets/img/act-notice/HD_gg_logo_1.png"),
    require("@/assets/img/act-notice/HD_gg_yq_1.png"),
    require("@/assets/img/act-notice/HD_hd_logo_1.png")
]